<div class="app-background-container">
  <div class="surface-card p-4 shadow-2 border-round w-full lg:w-6 max-w-30rem">
    <div class="text-center">
      <span class="email-icon-wrapper mb-3">
        <i class="pi pi-envelope big-email-icon"></i>
      </span>
      <div class="text-900 font-medium mb-2 text-3xl">Confirm Your Email</div>
      <div class="mb-2 text-primary font-medium" *ngIf="email">{{ email }}</div>
      <ul class="mb-4 text-left">
        <li>Check your inbox for an email from us.</li>
        <li>
          Click the confirmation link in the email to activate your account.
        </li>
        <li>
          If you don't see the email, please check your spam or junk folders.
        </li>
      </ul>
      <div class="flex gap-2">
        <button pButton pRipple label="Resend" class="p-button-outlined flex-1" (click)="resend()"
          type="button"></button>
        <button pButton pRipple label="Check" class="p-button flex-1" (click)="check()"></button>
      </div>
      <div class="mt-4">
        <button class="p-link p-button-link text-primary cursor-pointer p-0 border-0 bg-transparent"
          style="text-decoration: underline" (click)="signOut()" type="button">
          Sign out
        </button>
      </div>
    </div>
  </div>
</div>